import React from 'react';
import BaseModal from 'flow/components/ui-components/BaseModal';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import { useModal } from 'flow/contexts/ModalProvider';
import { selectContactName } from 'flow/selectors/ExtensionSelectors';
import { selectAssignee } from 'flow/selectors/TicketsSelectors';
import { TicketKey } from 'flow/types/EntityKeys';

interface Props {
    ticketKey?: TicketKey;
    handleAccept?: () => void;
    confirmButtonText?: string;
}

const ModalTicketStateChangeV2 = ({
    ticketKey,
    handleAccept,
    confirmButtonText,
}: Props) => {
    const { i18next } = useAppContext();
    const { previousModal } = useModal();
    const assignee = useAppSelector((state) =>
        ticketKey ? selectAssignee(state, ticketKey) : 'unassigned',
    );
    const assigneeName = useAppSelector((state) =>
        assignee !== 'unassigned' ? selectContactName(state, assignee) : '',
    );

    const onSubmit = () => {
        handleAccept?.();
        previousModal();
    };

    return (
        <BaseModal
            open={true}
            header={i18next.t('Confirm')}
            onSubmit={onSubmit}
            preventCloseOnSubmit={true}
            confirmButtonText={confirmButtonText || i18next.t('ok')}
        >
            {assignee === 'unassigned'
                ? i18next.t(
                      'This item is currently unassigned. Are you sure you want to change its status?',
                  )
                : i18next.t(
                      'This item is currently assigned to {{assignee}}. Are you sure you want to change its status?',
                      { assignee: assigneeName },
                  )}
        </BaseModal>
    );
};

export default ModalTicketStateChangeV2;
